import { MdAssignment, MdArticle, MdLightbulb, MdEco, MdEvent } from "react-icons/md";
import { useGetSubmissionStatsData } from "../../queries/dashboard";
import Section from "./Section";

const SubmissionStats = () => {

    const { data, isPending } = useGetSubmissionStatsData();

    const submissionData = {
        totalChallengeSubmissions: data?.totalChallengeSubmissions || 0,
        totalBlogSubmissions: data?.totalBlogSubmissions || 0,
        totalChallengeIdeaSubmissions: data?.totalChallengeProposals || 0,
        totalEcoActivitySubmissions: data?.totalEcoActivities || 0,
        totalEventSubmissions: data?.totalEventSubmissions || 0,
    };

    const SubmissionCard = ({ title, value, icon, color = "orange", colspan, rowspan }) => (
        <div className={`bg-white shadow border border-orange rounded-lg p-5 flex-1 min-w-[200px] ${color} flex flex-col gap-3 justify-between ${colspan ? ` col-span-${colspan}` : ''}${rowspan ? ` row-span-${rowspan}` : ''}`}>
            <div className='flex items-center justify-between'>
                <h3 className={`text-base font-extrabold text-${color}`}>{title}</h3>
                {icon && <span className={`text-2xl text-${color}`}>{icon}</span>}
            </div>
            <div className={`text-2xl font-bold text-${color}`}>
                {value}
            </div>
        </div>
    );

    return (
        <Section
            title={"Submission Statistics"}
            isLoading={isPending}
            gridCols={2}
            theme="orange"
        >
            <SubmissionCard
                title="Challenge Submissions"
                value={submissionData.totalChallengeSubmissions}
                icon={<MdAssignment />}
                color="orange"
            />
            <SubmissionCard
                title="Blog Submissions"
                value={submissionData.totalBlogSubmissions}
                icon={<MdArticle />}
                color="orange"
            />
            <SubmissionCard
                title="Eco Activity Submissions"
                value={submissionData.totalEcoActivitySubmissions}
                icon={<MdEco />}
                color="orange"
            />
            <SubmissionCard
                title="Event Submissions"
                value={submissionData.totalEventSubmissions}
                icon={<MdEvent />}
                color="orange"
            />
            <SubmissionCard
                title="Challenge Idea Submissions"
                value={submissionData.totalChallengeIdeaSubmissions}
                icon={<MdLightbulb />}
                color="orange"
                colspan={2}
            />
        </Section>
    );
};

export default SubmissionStats;